const cancelList = <any>{};
import CryptoJS from "crypto-js";
import base64 from "crypto-js/enc-base64";
import _ from "lodash";
import usePub from "~/store/Public";
import dayjs from "dayjs";
const encrypt = (text: any) => {
	const config = useRuntimeConfig();
	if (typeof text != "string") {
		text = JSON.stringify(text);
	}
	const key = base64.parse(config.public.API_KEY); //为了避免补位，直接用16位的秘钥
	const iv = CryptoJS.enc.Latin1.parse(config.public.APP_IV); //16位初始向量
	const encrypted = CryptoJS.AES.encrypt(text, key, {
		iv: iv,
		mode: CryptoJS.mode.CBC,
		padding: CryptoJS.pad.ZeroPadding,
	});
	return btoa(
		JSON.stringify({
			iv: config.public.APP_IV,
			value: encrypted.toString(),
			mac: CryptoJS.SHA512(iv).toString(),
		}),
	);
};
const queryData = (objectdata: any) => {
	var tmp: Array<any> = [];

	_.each(objectdata, (element, index) => {
		var val = typeof element == "string" || typeof element == "number" ? element : Array.isArray(element) ? element.join(",") : element ? JSON.stringify(element) : "";
		tmp.push(index + "=" + encodeURIComponent(val));
	});
	return "?" + tmp.join("&");
};
const generateUUID = () => {
	return ([1e7] + -1e3 + -4e3 + -8e3 + -1e11).replace(/[018]/g, (c) => (c ^ (crypto.getRandomValues(new Uint8Array(1))[0] & (15 >> (c / 4)))).toString(16));
};
const get = async (path: string, body: object | null = {}, header: Headers | null = null, cancelfunc: any = null) => {
	const { ssrContext } = useNuxtApp();
	const config = useRuntimeConfig();
	const queryList = queryData(body);
	const uuid = crypto.randomUUID() ?? generateUUID;
	const CancelRandom = (Math.random() * 100000).toString().replace(".", "__");
	if (!header) {
		header = new Headers({
			"Content-Type": "application/json",
			Authorization: "Bearer " + (!ssrContext ? localStorage.getItem("auth") || "" : ""),
			lang: !ssrContext ? localStorage.getItem("language") || "zh-tw" : "zh-tw",
		});
	} else {
		header.append("Authorization", "Bearer " + (!ssrContext ? localStorage.getItem("auth") || "" : ""));
		header.append("lang", !ssrContext ? localStorage.getItem("language") || "zh-tw" : "zh-tw");
	}
	const bodydata: RequestInit = {
		cache: "no-cache",
		method: "GET",
		headers: header,
	};
	if (cancelList[cancelfunc]) {
		try {
			_.each(cancelList[cancelfunc], (i, k) => {
				// cancelList[cancelfunc][k] ? cancelList[cancelfunc][k].abort() : "";
				i.abort();
			});
			delete cancelList[cancelfunc];
		} catch (e) {
			console.log(e);
		}
	}

	const signalCancel = cancelfunc || path.replace("/", "_");

	cancelList[signalCancel] = cancelList[signalCancel] || {};
	cancelList[signalCancel][CancelRandom] = new AbortController();
	bodydata.signal = cancelList[signalCancel][CancelRandom].signal;
	// cancelList[cancelfunc] = new AbortController();
	// bodydata.signal = cancelList[cancelfunc].signal;

	const API_URL = config.public.baseUrl;
	const tpath = path.search(/http/g) > -1 ? path : API_URL + path;
	usePub().responseObj.active[uuid] = {
		method: "get",
		// status: error.status,
		url: tpath + queryList,
		bodydata: bodydata,
		time: dayjs().format("YYYY-MM-DD HH:mm:ss"),
		uuid: uuid,
	};
	const s = fetch(tpath + queryList, bodydata)
		.then((response) => {
			delete usePub().responseObj.active[uuid];
			if (signalCancel && cancelList[signalCancel] && cancelList[signalCancel][CancelRandom]) {
				delete cancelList[signalCancel][CancelRandom];
				// delete cancelList[cancelfunc];
			}
			if (response.status !== 200) {
				throw response;
			}
			return response.json();
		})
		.catch(async (error) => {
			if (signalCancel && cancelList[signalCancel] && cancelList[signalCancel][CancelRandom]) {
				delete cancelList[signalCancel][CancelRandom];
				// delete cancelList[cancelfunc];
			}
			usePub().responseObj.error.push({
				method: "get",
				status: error.status,
				url: error.url,
				bodydata: bodydata,
				time: dayjs().format("YYYY-MM-DD HH:mm:ss"),
				uuid: uuid,
			});
			if (usePub().responseObj.error.length > 20) {
				for (let i = 20; i < usePub().responseObj.error.length; i++) {
					usePub().responseObj.error.splice(0, 1);
				}
			}

			if (error.status == 404) {
				return {
					static: false,
					message: "404",
				};
			}
			if (typeof error.data == "string") {
				return { static: false, result: { message: error.data } };
			}
			try {
				const t = await error.json();
				return {
					status: false,
					result: t.result,
				};
			} catch (e) {
				return {
					status: false,
					result: {
						message: "No Account",
					},
				};
			}
		});

	return s;
};
const refreshFormData = (formdata: FormData, data: any, pre: string = "") => {
	_.each(data, (item, field) => {
		let name = pre;
		if (name) {
			name += `[${field}]`;
		} else {
			name = field;
		}

		if (typeof item == "object" && !(item instanceof File)) {
			refreshFormData(formdata, item, name);
		} else {
			formdata.append(name, item);
		}
	});
	return formdata;
};
const matchUrl = async (method: string = "post", path: string, body: object | null = {}, header: Headers | null = null, cancelfunc: any = null) => {
	const { ssrContext } = useNuxtApp();
	const config = useRuntimeConfig();
	const CancelRandom = (Math.random() * 100000).toString().replace(".", "__");
	const uuid = crypto.randomUUID() ?? generateUUID;
	if (!header) {
		header = new Headers({
			Authorization: "Bearer " + (!ssrContext ? localStorage.getItem("auth") || "" : ""),
			lang: !ssrContext ? localStorage.getItem("language") || "zh-tw" : "zh-tw",
		});
	} else {
		header.append("Authorization", "Bearer " + (!ssrContext ? localStorage.getItem("auth") || "" : ""));
		header.append("lang", !ssrContext ? localStorage.getItem("language") || "zh-tw" : "zh-tw");
	}
	if (method !== "postform") {
		header.append("Content-Type", "application/json");
	}
	let response: any = {};
	if (method == "postform") {
		response = new FormData();
		refreshFormData(response, body);
	} else {
		response = JSON.stringify(body);
	}
	const bodydata: RequestInit = {
		body: response, // must match 'Content-Type' header
		cache: "no-cache",
		method: method == "postform" ? "post" : method,
		headers: header,
	};
	if (cancelList[cancelfunc]) {
		try {
			_.each(cancelList[cancelfunc], (i, k) => {
				// cancelList[cancelfunc][k] ? cancelList[cancelfunc][k].abort() : "";
				i.abort();
			});
			delete cancelList[cancelfunc];
		} catch (e) {
			console.log(e);
		}
	}

	const signalCancel = cancelfunc || path.replace("/", "_");
	cancelList[signalCancel] = cancelList[signalCancel] || {};
	cancelList[signalCancel][CancelRandom] = new AbortController();
	bodydata.signal = cancelList[signalCancel][CancelRandom].signal;

	const API_URL = config.public.baseUrl;
	usePub().responseObj.active[uuid] = {
		method: "Post",
		// status: error.status,
		url: API_URL + path,
		bodydata: bodydata,
		time: dayjs().format("YYYY-MM-DD HH:mm:ss"),
		uuid: uuid,
	};
	return await fetch(API_URL + path, bodydata)
		.then((response) => {
			delete usePub().responseObj.active[uuid];
			if (signalCancel && cancelList[signalCancel] && cancelList[signalCancel][CancelRandom]) {
				delete cancelList[signalCancel][CancelRandom];
			}
			if (response.status !== 200) {
				throw response;
			}

			return response.json();
		})
		.catch(async (error) => {
			// if (cancelfunc) {
			//     delete cancelList[cancelfunc];
			// }
			if (signalCancel && cancelList[signalCancel] && cancelList[signalCancel][CancelRandom]) {
				delete cancelList[signalCancel][CancelRandom];
			}
			if (error.status == 404) {
				return {
					static: false,
					message: "404",
				};
			}
			usePub().responseObj.error.push({
				method: "post",
				status: error.status,
				url: error.url,
				bodydata: bodydata,
				time: dayjs().format("YYYY-MM-DD HH:mm:ss"),
				uuid: uuid,
			});

			if (usePub().responseObj.error.length > 20) {
				for (let i = 20; i < usePub().responseObj.error.length; i++) {
					usePub().responseObj.error.splice(0, 1);
				}
			}
			if (typeof error.data == "string") {
				return { static: false, result: { message: error.data } };
			}
			try {
				const t = await error.json();

				return {
					status: false,
					result: t.result,
				};
			} catch (e) {
				return {
					status: false,
					result: {
						message: "No Account",
					},
				};
			}
		});
};
const postForm = (path: string, body: object | null = {}, header: Headers | null = null, cancelfunc: string | null = null) => {
	return matchUrl("postform", path, body, header, cancelfunc);
};

const post = (path: string, body: object | null = {}, header: Headers | null = null, cancelfunc: string | null = null) => {
	return matchUrl("post", path, body, header, cancelfunc);
};
const deletefunc = (path: string, body: object | null = {}, header: Headers | null = null, cancelfunc: string | null = null) => {
	return matchUrl("delete", path, body, header, cancelfunc);
};
const cancelFetch = (RcancelList: Array<string> = []) => {
	const exceCancelList = RcancelList.length == 0 ? _.keys(cancelList) : RcancelList;

	_.each(exceCancelList, (item) => {
		if (cancelList[item]) {
			_.each(cancelList[item], async (f, k) => {
				await cancelList[item][k].abort();
				delete cancelList[item][k];
			});
			_.keys(cancelList[item]).length == 0 ? delete cancelList[item] : "";
		}
	});
};
export default {
	get: get,
	post: post,
	postForm: postForm,
	delete: deletefunc,
	encrypt: encrypt,
	cancelFetch,
};
